import { useState } from 'react';
import { Card, Form, Row, Col, Table, Badge } from 'react-bootstrap';
import Loader from '../../Components/Loader';
import Message from '../../Components/Message';
import BackButton from '../../Components/BackButton';
import {
  useAdminListPartnerRedemptionsQuery,
  useAdminListPartnerCodesQuery,
  useAdminListPricingTiersQuery,
} from '../../slices/partnerCodesApiSlice';

const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString() : '—';

const PartnerRedemptionsScreen = () => {
  const [codeId, setCodeId] = useState('');
  const [tierId, setTierId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const { data: tiers = [] } = useAdminListPricingTiersQuery();
  const { data: codes = [] } = useAdminListPartnerCodesQuery();
  const {
    data: redemptions = [],
    isLoading,
    error,
  } = useAdminListPartnerRedemptionsQuery({
    codeId: codeId || undefined,
    tierId: tierId || undefined,
    startDate: startDate || undefined,
    endDate: endDate || undefined,
  });

  return (
    <>
      <BackButton />
      <Card className="shadow-sm">
        <Card.Body>
          <h4>Partner Redemptions</h4>
          <Row className="g-2 mb-3">
            <Col md={3}>
              <Form.Select value={codeId} onChange={(e) => setCodeId(e.target.value)}>
                <option value="">All codes</option>
                {codes.map((code) => (
                  <option key={code._id} value={code._id}>
                    {code.code}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Select value={tierId} onChange={(e) => setTierId(e.target.value)}>
                <option value="">All tiers</option>
                {tiers.map((tier) => (
                  <option key={tier._id} value={tier._id}>
                    {tier.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
          </Row>

          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message variant="danger">{error?.data?.message || error.error}</Message>
          ) : (
            <Table responsive hover className="table-sm">
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>USER</th>
                  <th>TIER</th>
                  <th>REDEEMED AT</th>
                </tr>
              </thead>
              <tbody>
                {redemptions.map((entry) => (
                  <tr key={entry._id}>
                    <td>{entry.partnerCode?.code || '—'}</td>
                    <td>
                      <div>{entry.user?.name || '—'}</div>
                      <div className="text-muted small">{entry.user?.email || ''}</div>
                    </td>
                    <td>
                      <Badge bg="info">
                        {tiers.find((tier) => String(tier._id) === String(entry.partnerCode?.tier))
                          ?.name || '—'}
                      </Badge>
                    </td>
                    <td>{formatDateTime(entry.redeemedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default PartnerRedemptionsScreen;
